import React from 'react'

import PEPEUSD from './assets/svg/Sticky/100KPEPE'
import AAVEUSD from './assets/svg/Sticky/AAVEUSD'
import ADAUSD from './assets/svg/Sticky/ADAUSD'
import ALGOUSD from './assets/svg/Sticky/ALGOUSD'
import APEUSD from './assets/svg/Sticky/APEUSD'
import APTOSUSD from './assets/svg/Sticky/APTOSUSD'
import ARBUSD from './assets/svg/Sticky/ARBUSD'
import ATOMUSD from './assets/svg/Sticky/ATOMUSD'
import AUDIOUSD from './assets/svg/Sticky/AUDIOUSD'
import AVAXUSD from './assets/svg/Sticky/AVAXUSD'
import BCHUSD from './assets/svg/Sticky/BCHUSD'
import BNBUSD from './assets/svg/Sticky/BNBUSD'
import BTCUSD from './assets/svg/Sticky/BTCUSD'
import CFXUSD from './assets/svg/Sticky/CFXUSD'
import CHZUSD from './assets/svg/Sticky/CHZUSD'
import COMPUSD from './assets/svg/Sticky/COMPUSD'
import CRVUSD from './assets/svg/Sticky/CRVUSD'
import DOGEUSD from './assets/svg/Sticky/DOGEUSD'
import DOTUSD from './assets/svg/Sticky/DOTUSD'
import EOSUSD from './assets/svg/Sticky/EOSUSD'
import ETCUSD from './assets/svg/Sticky/ETCUSD'
import ETHBTC from './assets/svg/Sticky/ETHBTC'
import ETHUSD from './assets/svg/Sticky/ETHUSD'
import FILUSD from './assets/svg/Sticky/FILUSD'
import FTMUSD from './assets/svg/Sticky/FTMUSD'
import LINAUSD from './assets/svg/Sticky/LINAUSD'
import LINKUSD from './assets/svg/Sticky/LINKUSD'
import LTCUSD from './assets/svg/Sticky/LTCUSD'
import MANAUSD from './assets/svg/Sticky/MANAUSD'
import MATICUSD from './assets/svg/Sticky/MATICUSD'
import MTLUSD from './assets/svg/Sticky/MTLUSD'
import NEARUSD from './assets/svg/Sticky/NEARUSD'
import OPUSD from './assets/svg/Sticky/OPUSD'
import SANDUSD from './assets/svg/Sticky/SANDUSD'
import SHIBUSD from './assets/svg/Sticky/SHIBUSD'
import SOLUSD from './assets/svg/Sticky/SOLUSD'
import SUIUSD from './assets/svg/Sticky/SUIUSD'
import SUSHIUSD from './assets/svg/Sticky/SUSHIUSD'
import UNIUSD from './assets/svg/Sticky/UNIUSD'
import XMRUSD from './assets/svg/Sticky/XMRUSD'
import XRPUSD from './assets/svg/Sticky/XRPUSD'
import BLZUSD from './assets/svg/Sticky/BLZUSD'
import LPTUSD from './assets/svg/Sticky/LPTUSD'
import RUNEUSD from './assets/svg/Sticky/RUNEUSD'
import GBPUSD from './assets/svg/Sticky/GBPUSD'
import EURUSD from './assets/svg/Sticky/EURUSD'
import KASUSD from './assets/svg/Sticky/KASUSD'
import LUNCUSD from './assets/svg/Sticky/LUNCUSD'
import INJUSD from './assets/svg/Sticky/INJUSD'
import RNDRUSD from './assets/svg/Sticky/RNDRUSD'
import KBONKUSD from './assets/svg/Sticky/KBONKUSD'
import FETUSD from './assets/svg/Sticky/FETUSD'
import JASMYUSD from './assets/svg/Sticky/JASMYUSD'
import ICPUSD from './assets/svg/Sticky/ICPUSD'
import KFLOKIUSD from './assets/svg/Sticky/KFLOKIUSD'
import TIAUSD from './assets/svg/Sticky/TIAUSD'
import STRKUSD from './assets/svg/Sticky/STRKUSD'
import AGIXUSD from './assets/svg/Sticky/AGIXUSD'
import TRXUSD from './assets/svg/Sticky/TRXUSD'
import JUPUSD from './assets/svg/Sticky/JUPUSD'
import THETAUSD from './assets/svg/Sticky/THETAUSD'
import TONUSD from './assets/svg/Sticky/TONUSD'
import GALAUSD from './assets/svg/Sticky/GALAUSD'
import POLUSD from './assets/svg/Sticky/POLUSD'

import { CURRENCIES } from './constants/currenciesIcons'
import { FacebookIcon, TelegramIcon, YoutubeIcon } from './assets/svg/'
import Coinmarketcap from './assets/svg/Coinmarketcap'
import styled from 'styled-components'
import WIFUSD from './assets/svg/Sticky/WIFUSD'
import STXUSD from './assets/svg/Sticky/STXUSD'

export const SEARCH_INDEX_NAME = 'pages'
export const SEARCH_INDICES = [{ name: SEARCH_INDEX_NAME, title: SEARCH_INDEX_NAME }]
export const GATSBY_ALGOLIA_APP_ID = process.env.GATSBY_ALGOLIA_APP_ID || ''
export const GATSBY_ALGOLIA_SEARCH_KEY = process.env.GATSBY_ALGOLIA_SEARCH_KEY || ''
export const GATSBY_MAIN_URL = process.env.GATSBY_MAIN_URL || 'https://margex.com/'
export const GATSBY_LOGIN_URL = process.env.GATSBY_LOGIN_URL || 'https://margex.ch/app/login'
export const GATSBY_SIGNUP_URL = process.env.GATSBY_SIGNUP_URL || 'https://margex.ch/app/signup'
export const GATSBY_TRADE_URL = process.env.GATSBY_TRADE_URL || 'https://margex.ch/app/trade'
export const HIT_ATTRIBUTES = {
  title: 'title',
  content: 'content',
  url: 'url',
}

export const DEFAULT_LOCALE = 'en'
export const MAIN_URL = '/help-center'
export const MARGEX_FUTURE_URL = 'https://future.margex.ch/'

const WS_BASE_URL = GATSBY_MAIN_URL?.replace('https://', 'wss://')

export const CANDLES_WS_URL = `${WS_BASE_URL}/client-candle/candles/websocket`
export const CANDLES_WS_TOPIC = '/topic/candles'

export const PAIRS_URL = `${GATSBY_MAIN_URL}/client-trade/api/v1/settings/pairsList`
export const COLLATERAL_URL = `${GATSBY_MAIN_URL}/client-payment/api/v1/collateral`
export const AUTH_PATH = `/security/api/v1/login`
export const PAIRS_PATH = `/client-trade/api/v1/settings/pairsList`

export const PAIRS_ICONS_BY_LABEL = {
  INJUSD,
  TRXUSD,
  FETUSD,
  JUPUSD,
  THETAUSD,
  STRKUSD,
  JASMYUSD,
  AGIXUSD,
  ICPUSD,
  RNDRUSD,
  XRPUSD,
  TONUSD,
  TIAUSD,
  ETHUSD,
  BTCUSD,
  EOSUSD,
  LTCUSD,
  UNIUSD,
  ETHBTC,
  SOLUSD,
  ADAUSD,
  BNBUSD,
  CHZUSD,
  LINKUSD,
  SANDUSD,
  AVAXUSD,
  BCHUSD,
  APEUSD,
  ETCUSD,
  ATOMUSD,
  APTOSUSD,
  APTUSD: APTOSUSD,
  MATICUSD,
  DOTUSD,
  ALGOUSD,
  MANAUSD,
  FTMUSD,
  XMRUSD,
  SUSHIUSD,
  DOGEUSD,
  ARBUSD,
  CFXUSD,
  LINAUSD,
  MTLUSD,
  OPUSD,
  AAVEUSD,
  AUDIOUSD,
  COMPUSD,
  FILUSD,
  NEARUSD,
  ['1KSHIBUSD']: SHIBUSD,
  SUIUSD,
  ['CRVUSD']: CRVUSD,
  ['100KPEPE']: PEPEUSD,
  ['1KBONKUSD']: KBONKUSD,
  ['1KFLOKIUSD']: KFLOKIUSD,
  BLZUSD,
  LPTUSD,
  RUNEUSD,
  EURUSD,
  GBPUSD,
  KASUSD,
  LUNCUSD,
  WIFUSD,
  STXUSD,
  POLUSD,
  GALAUSD,
} as { [key: string]: (props: React.SVGProps<SVGSVGElement>) => JSX.Element }

export const FETCH_GET_DEFAULT = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
  },
}

export const CHART_OPTIONS = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {
      display: false,
      title: {
        display: false,
      },
      ticks: {
        major: {
          enabled: false,
        },
      },
    },
    y: {
      display: false,
      title: {
        display: false,
      },
    },
  },
}

export const DEFAULT_DATASET = {
  pointRadius: 0,
  fill: false,
  borderColor: 'rgba(24, 160, 251, 1)',
  tension: 0.5,
  borderWidth: 1,
}

export const TRAIDING_PROFITS_OPTIONS = {
  maintainAspectRatio: false,
  responsive: true,
  tooltips: {
    enabled: false,
  },
  layout: {
    padding: {
      top: 30,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    showTooltips: false,
  },
  scales: {
    y: {
      display: false,
      type: 'logarithmic' as const,
      beginAtZero: true,
      max: 20000,
      min: 0,
      suggestedMax: 20000,
      suggestedMin: 0,
      ticks: {
        display: false,
      },
      grid: {
        display: false,
      },
    },
    x: {
      display: false,
      ticks: {
        display: false,
        fontSize: 20,
        fontColor: '#131622',
        fontFamily: 'Open Sans',
      },
      grid: {
        display: false,
      },
    },
  },
}

export const emptyHeaderPage = [
  '/page/empty-header-page',
  '/page/de/empty-header-page',
  '/page/fr/empty-header-page',
  '/page/es/empty-header-page',
  '/page/it/empty-header-page',
  '/page/pt/empty-header-page',
  '/page/tr/empty-header-page',
]
export const isEmptyHeaderPage = (pathname: string) => emptyHeaderPage.includes(pathname)

export const USD_RATES_MAPPING = {
  [CURRENCIES.BTC]: 1,
  [CURRENCIES.WBTC]: 1,
  [CURRENCIES.ETH]: 2,
  [CURRENCIES.ARB_ETH]: 2,
  [CURRENCIES.MATIC]: 3,
  [CURRENCIES.MATIC_ERC]: 3,
  [CURRENCIES.TRX]: 4,
  [CURRENCIES.LTC]: 5,
  [CURRENCIES.SOL]: 6,
  [CURRENCIES.LINK]: 7,
  [CURRENCIES.AVAX]: 8,
  [CURRENCIES.BNB]: 9,
  [CURRENCIES.XRP]: 10,

  [CURRENCIES.POL]: 3,
  [CURRENCIES.POL_ERC]: 3,
  [CURRENCIES.ALL_POL]: 3,
}

export const APPS_DOWNLOADER_LINKS = {
  margexAppLink: process.env.GATSBY_MARGEX_APP_LINK as string,
  margexApkLink: process.env.GATSBY_MARGEX_APK_LINK as string,
  copyAppLink: process.env.GATSBY_COPY_APP_LINK as string,
  copyApkLink: process.env.GATSBY_COPY_APK_LINK as string,
}

export const CONTACT_US_PHONE_NUMBER = '02188757137'

export const FA_SOCIAL = [
  // { url: 'https://twitter.com/margexcom', renderIcon: () => <TwitterIcon /> },
  { url: 'https://t.me/margex_community', renderIcon: () => <TelegramIcon /> },
  { url: 'https://www.facebook.com/margexcom', renderIcon: () => <FacebookIcon /> },
  { url: 'https://www.youtube.com/c/margex', renderIcon: () => <YoutubeIcon /> },
  {
    url: 'https://coinmarketcap.com/community/profile/margex/',
    renderIcon: () => (
      <CoinmarketcapContainer>
        <Coinmarketcap />
      </CoinmarketcapContainer>
    ),
  },
]

export const SOCIAL = [
  // { url: 'https://twitter.com/margexcom', renderIcon: () => <TwitterIcon /> },
  { url: 'https://t.me/margex_official', renderIcon: () => <TelegramIcon /> },
  { url: 'https://www.facebook.com/margexcom', renderIcon: () => <FacebookIcon /> },
  { url: 'https://www.youtube.com/c/margex', renderIcon: () => <YoutubeIcon /> },
  {
    url: 'https://coinmarketcap.com/community/profile/margex/',
    renderIcon: () => (
      <CoinmarketcapContainer>
        <Coinmarketcap />
      </CoinmarketcapContainer>
    ),
  },

  // { url: 'https://www.instagram.com/margexpersian_official/', renderIcon: () => <InstagramIcon /> },
]

export const LOCAL_STORAGE_LOCALE_KEY = 'locale'

const CoinmarketcapContainer = styled.div(() => ({
  marginLeft: -8,
}))
